export default "__VITE_ASSET__sMniIr7j__"